import React from 'react'
import styled, { css } from 'styled-components'
import Box from '@components/Box'
import { STypographyDefault, STypographyDesc, STypography } from '@components/Typography'
import { above } from '@styles/mixins/breakpoints'
import theme from '@styles/theme'

type Item = {
  cost: string
  text: string
}

type SCardProps = {
  additionText: string
  mainItem: Item
  items: Item[]
}

export const SDevider = styled.div`
  margin: 24px 0;
  flex-grow: 0;
  flex-shrink: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.steelGray};
  height: 1px;
  width: 100%;

  ${above('xl')(css`
    margin: 0 80px;
    width: 1px;
    height: auto;
    min-height: 100%;
    border-top: none;
    border-right: 1px solid ${({ theme }) => theme.colors.steelGray};
  `)}
`

const SSocialPackBlock: React.FC<SCardProps> = ({ additionText, mainItem, items }) => (
  <>
    <Box display="flex" mb={{ md: '32px', xl: '20px' }} pr={{ xl: '300px' }} flexWrap={{ xs: 'wrap', xl: 'nowrap' }}>
      <Box
        display="flex"
        minWidth={{ md: '100%', xl: '0' }}
        maxWidth={{ xl: '188px' }}
        flexWrap={{ xs: 'wrap', md: 'nowrap' }}
        flexDirection={{ xs: 'row', xl: 'column' }}
      >
        <STypography
          fontSize="36px"
          lineHeight="44px"
          fontWeight="600"
          mr={{ xs: '20px', md: 0 }}
          fontFamily={theme.typography.headingFontFamily}
          color={theme.colors.green}
        >
          {mainItem.cost}
        </STypography>
        <Box ml={{ md: '24px', xl: 0 }} maxWidth={{ md: '188px', xl: 'none' }}>
          <STypographyDefault dangerouslySetInnerHTML={{ __html: mainItem.text }} />
        </Box>
      </Box>
      <SDevider />
      <Box display="flex" flexWrap={{ xs: 'wrap', md: 'nowrap' }} mr={{ md: '140px', xl: 0 }}>
        {items.map((item, idx) => (
          <Box
            display="flex"
            key={idx}
            width={
              idx === 0
                ? { xs: '100%', md: '176px' }
                : idx === 1
                ? { xs: '100%', md: '148px' }
                : { xs: '100%', md: '105px' }
            }
            mb={{ xs: '24px', md: 0 }}
            flexDirection="column"
            mr={idx !== items.length - 1 ? { xs: '20px', md: '60px', xl: '40px' } : 0}
          >
            <Box mb="8px">
              <Box
                style={{ backgroundColor: '#e9f5eb', borderRadius: '4px' }}
                display="inline-block"
                padding="4px 12px"
              >
                <STypography fontSize="16px" lineHeight="24px" fontWeight="600" color={theme.colors.green}>
                  {item.cost}
                </STypography>
              </Box>
            </Box>
            <Box width={idx === 0 ? { xl: '187px' } : {}} mr={idx === 0 ? { xl: '30px' } : {}}>
              <STypographyDefault width="100%" dangerouslySetInnerHTML={{ __html: item.text }} />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
    <STypographyDesc mt={{ xs: '12px', md: 0 }} color={theme.colors.darkGray}>
      {additionText}
    </STypographyDesc>
  </>
)

export default SSocialPackBlock
